


























import Vue from 'vue';
import Component from 'nuxt-class-component';
import Footer from '@components/Footer.vue';
import LoginForm from '@components/auth/LoginForm.vue';
import { getPageTitle } from '@shared/constants/copy';
import NuxtService from '@client/sevices/NuxtService';

@Component({
    components: { LoginForm, Footer },
})
export default class LoginPage extends Vue {
    name = 'LoginPage';
    showLoggedInMessage: boolean = false;

    mounted() {
        if (this.$auth.loggedIn) {
            this.showLoggedInMessage = true;
        }
    }

    get loggedInMessage(): string {
        const email = this.$auth.user?.email;
        if (email) {
            return `You are currently logged in as ${email}`;
        } else {
            return 'You are currently logged in.';
        }
    }

    logout() {
        NuxtService.shared.logout();
    }

    head() {
        return {
            title: getPageTitle('Log In', this.$config),
        };
    }
}
